// extracted by mini-css-extract-plugin
export default {"card":"styles_card__brIkU","card_title":"styles_card_title__1DAJl","card_content":"styles_card_content__jJtIU"};